import { formatFullWIB } from "@/lib/datetime";

// Sinkronisasi Stase dari Rotasi Klinik: label & teks kartu (angka dari server, lihat sinkron_stase.py).
export const STASE_IKUT_ROTASI = ["Stase RSCM", "Stase Luar"];

// Kategori SAMA dgn SS.KATEGORI di server.
export const LABEL_KATEGORI = [
    ["rscm_ke_luar", "Akan berubah: Stase RSCM → Stase Luar"],
    ["luar_ke_rscm", "Akan berubah: Stase Luar → Stase RSCM"],
    ["sama", "Sudah sama dengan Rotasi"],
    ["konflik", "Konflik: RSCM dan Luar bersamaan (dilewati)"],
    ["tanpa_rotasi", "Tanpa rotasi hari ini (dibiarkan)"],
    ["luar_tanpa_tanggal", "Hanya punya Stase Luar tanpa tanggal lengkap (dibiarkan)"],
    ["terkunci", "Stase dikunci (dilewati)"],
    ["perlu_dicek", "MDU-MDK, Penelitian, atau Belum Stase yang punya rotasi hari ini (perlu dicek, tidak diubah)"],
    ["lainnya", "Stase kosong atau tidak dikenal (tidak diproses)"],
];

export const KOLOM_RINCIAN = [
    ["rscm_ke_luar", "RSCM → Luar"],
    ["luar_ke_rscm", "Luar → RSCM"],
    ["sama", "Sama"],
    ["konflik", "Konflik"],
    ["tanpa_rotasi", "Tanpa rotasi"],
    ["terkunci", "Terkunci"],
    ["perlu_dicek", "Perlu dicek"],
    ["lainnya", "Lainnya"],
];

export const jumlahBerubah = (hitungan) => (hitungan?.rscm_ke_luar || 0) + (hitungan?.luar_ke_rscm || 0);

const LABEL_PEMICU = { manual: "manual", terjadwal: "terjadwal" };
const LABEL_STATUS = { selesai: "selesai", gagal: "gagal", dihentikan: "dihentikan saklar", berjalan: "berjalan" };

export function teksJalan(jalan) {
    if (!jalan) return null;
    return `${formatFullWIB(jalan.selesai || jalan.mulai)} · ${LABEL_PEMICU[jalan.pemicu] || jalan.pemicu} · `
        + `${LABEL_STATUS[jalan.status] || jalan.status} · ${jalan.diubah} Stase diubah`;
}

export const teksSelisihHari = (selisih) => {
    const angka = Number(selisih || 0);
    return `${angka > 0 ? "+" : ""}${angka.toLocaleString("id-ID")} hari`;
};

// Keterangan di dialog Edit Peserta. Hanya Aktif ber-Stase RSCM/Luar yang bisa diikuti; null = tidak tampil.
export function keteranganIkutRotasi({ saklarAktif, terkunci, stase, status }) {
    if (!saklarAktif || status !== "Aktif" || !STASE_IKUT_ROTASI.includes(stase)) return null;
    return terkunci ? "Stase dikunci: tidak mengikuti Rotasi Klinik." : "Stase mengikuti Rotasi Klinik. Ubah di Rotasi.";
}
